import AppDataService from "./AppDataService";

const COMMON_BASE = 'SubmitForms'

export default class SubmitFormsDataService {

    static async getSubmittedFormsList(params) {
        return await AppDataService.post(`${COMMON_BASE}/GetList`, params)
    }

    static async resetCascadePayersForGridCache() {
        return await AppDataService.get(`${COMMON_BASE}/ResetCascadePayersForGridCache`)
    }

    static async deleteForms(data) {
        return await AppDataService.delete(`${COMMON_BASE}/DeleteAll`, data)
    }

    static async deleteSingleForm({ formSubmissionId, formId }) {
        return await AppDataService.delete(`${COMMON_BASE}/DeleteForm?formSubmissionId=${formSubmissionId}&formId=${formId}`)
    }

    static async createZipForDownloadAll(data) {
        return await AppDataService.post(`${COMMON_BASE}/CreatePdf`, data)
    }

    static async downloadMultiplePDF(payerName, FormName) {
        return await AppDataService.get(`${COMMON_BASE}/DownloadAll?payerName=${payerName}&FormName=${FormName}`)
    }

    static async downloadSinglePDF(data) {
        return await AppDataService.post(`${COMMON_BASE}/PdfPreview`, data)
    }

    static async calculateTax1099FeeAmount(data) {
        return await AppDataService.post(`${COMMON_BASE}/CalculateAmount`, data)
    }

    static async getSumAmountBoxDetail(payerId, taxYearId, formId, Corrected, status) {
        return await AppDataService.post(`${COMMON_BASE}/GetSumAmountBoxDetail?payerId=${payerId}&taxYearId=${taxYearId}&formId=${formId}&Corrected=${Corrected}&status=${status}`)
    }

    static async getSubmitAllPayersGridList(data) {
        return await AppDataService.post(`${COMMON_BASE}/SubmitAllPayersGridList`, data)
    }

    static async getListofAllPayersPayment(data) {
        return await AppDataService.post(`${COMMON_BASE}/GetListofAllPayersPayment`, data)
    }

    static async exportToExcel(data) {
        return await AppDataService.post(`${COMMON_BASE}/ExportToExcel`, data)
    }

    static async changeScheduleDataForAllVendor(data) {
        return await AppDataService.post(`${COMMON_BASE}/SaveScheduleDateForAll`, data)
    }

    //Update ready to submit:- select all checkbox
    static async rtsSelectAllCheckbox(data) {
        return await AppDataService.post(`${COMMON_BASE}/SelectAllInAllPages`, data)
    }

    //Update ready to submit:- usps mail checkbox
    static async rtsUSPSMailCheckbox(data) {
        return await AppDataService.post(`${COMMON_BASE}/SelectAllInAllPagesUSPS`, data)
    }

    //Update ready to submit:- recipient mail checkbox
    static async rtsRecipientMailCheckbox(data) {
        return await AppDataService.post(`${COMMON_BASE}/SelectAllInAllPagesEmail`, data)
    }

    //Update ready to submit:- tin match checkbox
    static async rtsTinMatchCheckbox(data) {
        return await AppDataService.post(`${COMMON_BASE}/SelectAllInAllPagesTinMatch`, data)
    }

    //Update ready to submit:- state filing checkbox
    static async rtsStateFilingCheckbox(data) {
        return await AppDataService.post(`${COMMON_BASE}/SelectAllInAllPagesStateFiling`, data)
    }

    static async submitForSinglePayer(data) {
        return await AppDataService.post(`${COMMON_BASE}/SubmitPayer`, data)
    }

    static async loadFormsData(data) {
        return await AppDataService.post(`${COMMON_BASE}/LoadFormsData`, data);
    }

    static async getForm1094CStatus(payerId) {
        return await AppDataService.get(`${COMMON_BASE}/GetForm1094CStatus?payerid=${payerId}`)
    }

    static async getScheduledDates(){
        return await AppDataService.get(`${COMMON_BASE}/GetScheduledDates`);
    }

    static async getScheduledDatesStatus(params) {
        return await AppDataService.get(`${COMMON_BASE}/EnableScheduleDate`, { params });
    }

    static async setCheckboxSubmitForAllPayer(data){
        return await AppDataService.post(`${COMMON_BASE}/SetAllCheckboxSubmitForAllPayers`, data);
    }

    static async clearList() {
        return await AppDataService.get(`${COMMON_BASE}/ClearList`);
    }

    static async getStateList() {
        return await AppDataService.get(`${COMMON_BASE}/GetStatePayrollStates`);
    }

    static async getFormList(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetStatePayrollFormNames?stateName=${params}`);
    }

    static async getTaxYear(){
        return await AppDataService.get(`${COMMON_BASE}/GetStatePayrollTaxYears`);
    }

    static async getStatePayrollSubmittedFormsList(params) {
        return await AppDataService.post(`${COMMON_BASE}/GetStatePayrollList`, params)
    }

    static async viewStatePayrollPDF(params) {
        return await AppDataService.post(`${COMMON_BASE}/StatePayrollPdfPreview`, params)
    }

    static async loadStatePayrollFormsData(params) {
        return await AppDataService.post(`${COMMON_BASE}/LoadStatePayrollFormsData`, params)
    }

    static async deleteStatePayrollForms(data){
        return await AppDataService.delete(`${COMMON_BASE}/DeleteStatePayrollBulkForms`, data)
    }

    static async createStatePayrollZipForDownloadAll(data) {
        return await AppDataService.post(`${COMMON_BASE}/DownloadStatePayrollPdfAll`, data)
    }
    
    static async downloadStatePayrollMultiplePDF(formName) {
        return await AppDataService.get(`${COMMON_BASE}/DownloadStatePayrollPDFZip?formName=${formName}`)
    }
}